import { Icon } from '@docs/kd-d2c-components';
import intl from '@/internationalzation/intl';
import {
  process_title_done,
  step_circle,
  thinking_process_arrow,
} from '@src/assets/icons';
import { StepProcessStatus } from '@src/types';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import './step-process.less';
import { useComputerData } from '@src/stores/useComputerData';
import { Tooltip } from 'antd';
interface Props {
  status: StepProcessStatus;
  defaultExpend?: boolean;
  title?: string;
  children?: React.ReactNode[];
}
const StepProcess = ({
  status,
  defaultExpend = true,
  title = '',
  children,
}: Props) => {
  const { activeStepByContent } = useComputerData();
  const [isExpend, setIsExpend] = useState(defaultExpend);
  const isRunning = status === StepProcessStatus.RUNNING;
  const [textOverflow, setTextOverflow] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const titleRef = useRef<HTMLDivElement>(null);

  // 检测文本是否溢出
  const checkTextOverflow = () => {
    if (titleRef.current) {
      setTextOverflow(
        titleRef.current.scrollWidth > titleRef.current.clientWidth,
      );
    }
  };

  useEffect(() => {
    activeStepByContent(title);
  }, [title]);

  // 监听元素大小变化和标题变化，重新检测文本是否溢出
  useEffect(() => {
    // 初始检查文本溢出
    checkTextOverflow();

    // 确保DOM已渲染并且引用可用
    if (!titleRef.current) return;

    // 使用ResizeObserver监听元素大小变化
    const resizeObserver = new ResizeObserver(() => {
      checkTextOverflow();
    });

    resizeObserver.observe(titleRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [title]); // 添加title作为依赖，确保title变化时重新设置观察者

  return (
    <div className="step-process">
      <div className="step-process-bar" onClick={() => setIsExpend(!isExpend)}>
        <Icon
          icon={isRunning ? step_circle : process_title_done}
          color="var(--color-text-quaternary)"
          className="step-process-status-icon"
        />
        <Tooltip
          title={title}
          placement="top"
          open={textOverflow && isHovering}
        >
          <div
            className="step-process-title single-line-text"
            ref={titleRef}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
          >
            {title}
          </div>
        </Tooltip>
        <Icon
          className={classNames('step-process-thinking-icon', {
            rotate180: !isExpend,
          })}
          icon={thinking_process_arrow}
          color="var(--color-text-primary)"
        />
      </div>
      <div
        className="step-process-content"
        style={{
          display: isExpend ? 'block' : 'none',
        }}
      >
        {children}
      </div>
    </div>
  );
};
export default StepProcess;
export const Demo = () => {
  return (
    <div
      style={{
        padding: 40,
        display: 'flex',
        gap: 12,
        flexDirection: 'column',
      }}
    >
      <StepProcess
        status={StepProcessStatus.DONE}
        title={intl.t('解析RSS内容')}
      />
      <StepProcess
        status={StepProcessStatus.RUNNING}
        title={intl.t('提取最新版本信息')}
      />
    </div>
  );
};
